import './style.scss'

interface AppFormButtonProps {
	label: string
	icon?: string
	disabled?: boolean
	fullWidth?: boolean
	onClick: () => void
	size: 'small' | 'medium' | 'large'
	style?: 'primary' | 'secondary' | 'alt'
}

function AppFormButton({label, icon, disabled, fullWidth, onClick, size = 'medium', style = 'primary'}: AppFormButtonProps) {

	const buttonClickHandler = () => {
		if (!disabled) {
			onClick()
		}
	}

	return (
		<button 
			className={`app-form-button ${disabled ? 'disabled' : ''} ${size} ${fullWidth ? 'app-form-button-full-width' : ''} app-form-button-${style}`}
			onClick={(event) => { 
				event.stopPropagation()
				buttonClickHandler() 
			}}
			disabled={disabled}
		>
			<div className='app-form-button-label'>
				{label}
			</div>
			{icon && (
				<img 
					src={icon}
					className='app-form-button-icon' 
					alt='cta button icon'
				/>
			)}
		</button>
	)
}

export default AppFormButton
